import { useEffect, useState } from "react";
import { Layout, Result } from "antd";
import SideBar from "./layout/sider/component";
import { Content } from "antd/es/layout/layout";
import HeadComponent from "./layout/header/component";
import { Route, Routes, useNavigate } from "react-router-dom";
import ArtWorkList from "./components/artwork/list/component";
import ViewArtworks from "./components/artwork/view-artwork/component";
import UserList from "./components/user/list/component";
import UsersAddEdit from "./components/user/add-or-edit/component";

const Home = (props: any) => {
    const { userId, userEmail, userName, userRole, userStatus, profilePath } = props;
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        const redirect = async () => {
            if (window.location.pathname === '/') {
                await navigate('/artwork');
                return;
            }
            await navigate(window.location.pathname);
        };
        redirect();
    }, []);

    const handleMobileMenuToggle = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleMobileMenuClose = () => {
        setIsMobileMenuOpen(false);
    };

    return (
        <main className="app-main">
            <Layout className="app-layout">
                <SideBar 
                    userRole={userRole} 
                    userStatus={userStatus} 
                    profilePath={profilePath}
                    isMobileMenuOpen={isMobileMenuOpen}
                    onMobileMenuClose={handleMobileMenuClose}
                />
                <Layout className="main-content-layout">
                    <HeadComponent 
                        userEmail={userEmail} 
                        userName={userName} 
                        profilePath={profilePath}
                        onMobileMenuToggle={handleMobileMenuToggle}
                        isMobileMenuOpen={isMobileMenuOpen}
                    />
                    {userStatus === 'Enable' ?
                        <Content className="main-content">
                            <Routes>
                                <Route path='artwork' element={<ArtWorkList userName={userName} userId={userId} />} ></Route>
                                <Route path='artwork/:id' element={<ViewArtworks userName={userName} userId={userId} userEmail={userEmail} />} ></Route>
                                <Route path='user' element={<UserList />} ></Route>
                                <Route path='user/add' element={<UsersAddEdit />} ></Route>
                                <Route path='user/edit/:id' element={<UsersAddEdit />} ></Route>
                            </Routes>
                        </Content>
                        : <Result
                            status="403"
                            title="403"
                            subTitle="Sorry, you are not authorized to access this page."
                            extra={null}
                        />
                    }
                </Layout>
            </Layout>
        </main>
    );
};
export default Home;